module.exports = __webpack_public_path__ + "img/prp_ultraplatinum.d44e7648.png";